<template>
  <v-form ref="form" @submit.prevent="submit">
    <v-card width="500" class="pa-4 mx-auto mt-9" flat outlined>
      <v-snackbar
        v-model="showNotification"
        :timeout="timeout"
        :top="y === 'top'"
        dark
        :color="color"
      >
        {{ notificationMsg }}
      </v-snackbar>
      <div class="pt-4 px-4 text-center">
        <v-icon style="font-size: 8rem">mdi-account-circle</v-icon>
      </div>
      <v-card-title class="text-h5 justify-center"
        >Profile Settings</v-card-title
      >
      <v-card-text>
        <v-text-field
          v-model="userData.name"
          prepend-icon="mdi-account-circle"
          :rules="inputRules"
          required="true"
        >
          <template v-slot:label>
            Name
            <span class="red--text">*</span>
          </template>
        </v-text-field>

        <v-text-field
          v-model="userData.email"
          prepend-icon="mdi-email"
          :readonly="true"
          class="mt-n2 mb-2"
        >
          <template v-slot:label>
            Email
            <span class="red--text">*</span>
          </template>
        </v-text-field>

        <v-select
          v-model="userData.organizationType"
          :items="orgTypes"
          item-text="title"
          item-value="title"
          prepend-icon="mdi-format-align-left"
          required="true"
        >
          <template v-slot:label>
            Type of organization
            <span class="red--text">*</span>
          </template>
        </v-select>

        <!-- <v-checkbox
          v-model="userData.settings.isSubscribedToNewsLetter"
          label="Receive newsletter"
          color="primary"
          hide-details
          prepend-icon="mdi-newspaper"
        ></v-checkbox> -->

        <v-layout row wrap ml-0>
          <v-flex>
            <v-checkbox
              v-model="userData.settings.isProjectInfoShareable"
              label="Permit project data to be shared publicly"
              color="primary"
              prepend-icon="mdi-share-variant"
              hide-details
            />
          </v-flex>
          <div class="px-4 text-subtitle1 my-4">
            Note: This setting allows Solva & Auroville Consulting to share project information, load profile data and reports publicly. When this is not selected, you will not be able to publish projects.
            Published projects allow all users on Solva to view project data and reports.
          </div>
        </v-layout>
        <v-layout row wrap ml-0>
          <v-flex>
            <v-checkbox
              v-model="userData.settings.isSubscribedToNewsLetter"
              label="Subscribe Newsletter"
              color="primary"
              hide-details
            ></v-checkbox> 
          </v-flex>
        </v-layout>
      </v-card-text>

      <v-card-actions class="pa-4 mt-4 justify-center">
        <v-btn
          color="primary"
          type="submit"
          :loading="loading"
          class="text-capitalize"
          :disabled="isSaveDisabled()"
        >
          Save Settings
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</template>
<script>
import authService from "@/services/auth";
import dataService from "@/libs/dataService.js";
// import Tooltips from "@/components/tooltips.vue";
import TooltipsData from "@/services/lableTooltips.js";
import settingsUtility from "@/utility/settingsUtility";
import { isEqual, cloneDeep } from "lodash";

export default {
  name: "MySettings",
  components: {
    // Tooltips,
  },
  data() {
    return {
      initialUserData: null,
      permitLoadProfilesToBeStoredAndSharedTooltip: "",
      userData: {
        id: "",
        name: "",
        email: "",
        organizationType: "",
        settings: {
          // isSubscribedToNewsLetter: false,
          isProjectInfoShareable: false,
          isSubscribedToNewsLetter: false,
        },
      },
      orgTypes: [],
      notificationMsg: "",
      loading: false,
      inputRules: [(v) => !!v || "This field is required"],
      showNotification: false,
      timeout: 5000,
      y: "top",
      color: "orange",
    };
  },
  mounted() {
    this.getMySettings();
    this.getOrganizationTypes();
    // this.fillToolTips();
  },
  methods: {
    isSaveDisabled() {
      return isEqual(this.initialUserData, this.userData);
    },
    getOrganizationTypes() {
      dataService
        .list("organizationTypes")
        .then((res) => (this.orgTypes = res));
    },
    fillToolTips() {
      this.permitLoadProfilesToBeStoredAndSharedTooltip =
        TooltipsData.methods.getTooltips("shareLoadProfile");
    },
    getMySettings() {
      const data = settingsUtility.methods.getData();
      if (data === null) {
        this.$router.push("/login");
      } else {
        const { _id, email, name, organizationType, settings } = data;
        this.userData = {
          id: _id,
          name,
          email,
          organizationType,
          settings: {
            // isSubscribedToNewsLetter: false,
            isProjectInfoShareable: false,
            isSubscribedToNewsLetter: false,
          },
        };
        if (settings) {
          // this.userData.settings.isSubscribedToNewsLetter =
          //   settings.isSubscribedToNewsLetter ? true : false;
          this.userData.settings.isProjectInfoShareable =
            settings.isProjectInfoShareable ? true : false;
          this.userData.settings.isSubscribedToNewsLetter = 
            settings.isSubscribedToNewsLetter ? true : false;
        }
        this.initialUserData = cloneDeep(this.userData);
      }
    },
    submit() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        // console.log("payload", this.userData);
        const payload = { ...this.userData };
        delete payload["id"];
        delete payload["email"];
        authService
          .saveSettings(this.userData.id, payload)
          .then((res) => {
            this.loading = false;
            if (res.data.success === true) {
              this.color = "green";
              this.notificationMsg =
                "Your Profile has been updated successfully!";
              this.showNotification = true;
              settingsUtility.methods.patchData(payload);
            }
          })
          .catch(() => {
            this.color = "red";
            this.loading = false;
            this.notificationMsg =
              "An error occurred while saving profile settings.";
            this.showNotification = true;
          });
      }
    },
  },
};
</script>